import { t } from "ttag";

export const APPLICATION_PERMISSIONS_OPTIONS = {
  yes: {
    label: t`Yes`,
    value: "yes",
    icon: "check",
    iconColor: "success",
  },
  no: {
    label: t`No`,
    value: "no",
    icon: "close",
    iconColor: "danger",
  },
};
